"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingButton = void 0;
const react_1 = __importDefault(require("react"));
const react_tiny_fab_1 = require("react-tiny-fab");
const styled_components_1 = require("styled-components");
require("react-tiny-fab/dist/styles.css");
require("./floating-button.css");
;
;
;
/**
  * Main component.
  * @name FloatingButton
  * @param {FloatingButtonProps}
  * @returns {<FloatingButton />}
*/
const FloatingButton = ({ communicationChannels = [], mainButtonStyles, icon, alwaysShowTitle = false, onClick, text, position, mobilePosition }) => {
    const GlobalStyles = (0, styled_components_1.createGlobalStyle) `
        
        :root {
            --fab-container-desktop-position-bottom: ${(position === null || position === void 0 ? void 0 : position.bottom) || '24px'};
            --fab-container-desktop-position-right: ${(position === null || position === void 0 ? void 0 : position.right) || '24px'};
            --fab-container-desktop-position-left: ${position === null || position === void 0 ? void 0 : position.left};
            --fab-container-desktop-padding: ${position === null || position === void 0 ? void 0 : position.padding};
            --fab-container-mobile-position-bottom: ${(mobilePosition === null || mobilePosition === void 0 ? void 0 : mobilePosition.bottom) || '40px'};
            --fab-container-mobile-position-right: ${(mobilePosition === null || mobilePosition === void 0 ? void 0 : mobilePosition.right) || '5px'};
            --fab-container-mobile-position-left: ${mobilePosition === null || mobilePosition === void 0 ? void 0 : mobilePosition.left};
            --fab-container-mobile-padding: ${mobilePosition === null || mobilePosition === void 0 ? void 0 : mobilePosition.padding};
        }

        .fab-container .rtf {
            bottom: var(--fab-container-desktop-position-bottom) !important;
            right: var(--fab-container-desktop-position-right) !important;
            left: var(--fab-container-desktop-position-left) !important;
            padding: var(--fab-container-desktop-padding) !important;
        }

        @media( max-width: 500px ) {

            .fab-container .rtf {
                bottom: var(--fab-container-mobile-position-bottom) !important;
                right: var(--fab-container-mobile-position-right) !important;
                left: var(--fab-container-mobile-position-left) !important;
                padding: var(--fab-container-mobile-padding) !important;
                margin: 15px;
            }

            .fab-container .rtf .rtf--mb__c .rtf--mb {
                width: 60px !important;
                height: 60px;
            }
        }

    `;
    const handleClick = (link) => {
        window.open(`${link}`, "_blank");
    };
    return (react_1.default.createElement("div", { className: 'fab-container' },
        react_1.default.createElement(GlobalStyles, null),
        react_1.default.createElement(react_tiny_fab_1.Fab, { text: text, mainButtonStyles: mainButtonStyles, alwaysShowTitle: alwaysShowTitle, icon: react_1.default.createElement("img", { src: icon, alt: '', style: { width: 28 } }), onClick: onClick }, communicationChannels.map(({ color, icon, link, text }) => (react_1.default.createElement(react_tiny_fab_1.Action, { text: text, style: { backgroundColor: `${color}`, width: 40, height: 40 }, onClick: () => handleClick(link) },
            react_1.default.createElement("img", { src: icon, alt: text, style: { width: 19 } })))))));
};
exports.FloatingButton = FloatingButton;
//# sourceMappingURL=floating-button.js.map